/** Pull { field: message } out of a zod result or a Laravel 422 payload. */
export const toFieldErrors = (issuesOrDetails) => {
  const out = {}
  if (Array.isArray(issuesOrDetails)) {
    for (const issue of issuesOrDetails) out[issue.path[0]] ??= issue.message
  } else if (issuesOrDetails && typeof issuesOrDetails === 'object') {
    for (const [field, messages] of Object.entries(issuesOrDetails))
      out[field] = Array.isArray(messages) ? messages[0] : String(messages)
  }
  return out
}

/**
 * Only a 4xx carries copy meant for a person (unknown email, throttled, invalid
 * token). A 5xx or a network drop is our problem, not something to quote at the
 * user — those fall back to our own line.
 */
export const userFacingMessage = (err, fallback) => {
  const { status, message } = err.error
  return status >= 400 && status < 500 && message ? message : fallback
}
